import { Badge } from "../components/ui/badge";
import { cn } from "./utils";

export const CATEGORY_LABEL = {
  INTERESSATO: "Cliente interessato",
  INTERESSATO_NI: "Interessato classificato NI",
  INTERESSATO_ALTRO_NEGATIVO: "Interessato con altro esito negativo",
  RICHIAMATA_RICHIESTA: "Richiesta richiamata",
  RICHIAMATA_DIMENTICATA: "Richiamata potenzialmente dimenticata",
  OPPORTUNITA_GESTITA_MALE: "Opportunità da valorizzare",
  INTERESSE_INCERTO: "Interesse incerto",
  RIFIUTO_REALE: "Rifiuto reale",
  NON_CONTATTARE: "Non contattare",
  AUDIO_INSUFFICIENTE: "Audio insufficiente",
};

const CAT_TONE = {
  INTERESSATO: "green", INTERESSATO_NI: "blue", INTERESSATO_ALTRO_NEGATIVO: "blue", RICHIAMATA_RICHIESTA: "amber",
  RICHIAMATA_DIMENTICATA: "amber", OPPORTUNITA_GESTITA_MALE: "blue", INTERESSE_INCERTO: "gray",
  RIFIUTO_REALE: "gray", NON_CONTATTARE: "red", AUDIO_INSUFFICIENTE: "gray",
};

export const REVIEW_LABEL = { pending: "Da verificare", approved: "Approvato", rejected: "Rifiutato", needs_review: "Da rivedere" };
const REVIEW_TONE = { pending: "gray", approved: "green", rejected: "red", needs_review: "amber" };

export const REC_STATUS = {
  discovered: "Individuata", queued: "In coda", acquiring: "Acquisizione", acquired: "Acquisita", transcribing: "Trascrizione",
  transcribed: "Trascritta", classifying: "Classificazione", classified: "Analizzata", error: "Errore",
};
const REC_TONE = { classified: "green", error: "red", acquired: "blue", transcribed: "blue" };

export const JOB_STATUS = {
  queued: "In coda", running: "In esecuzione", paused: "In pausa", completed: "Completato",
  completed_errors: "Completato con errori", cancelled: "Annullato", failed: "Fallito",
};
const JOB_TONE = { running: "blue", completed: "green", completed_errors: "amber", failed: "red", paused: "amber", cancelled: "gray" };

export const CHECK_LABEL = { ok: "Operativo", warning: "Attenzione", error: "Errore", unverified: "Non verificato" };
const CHECK_TONE = { ok: "green", warning: "amber", error: "red", unverified: "gray" };

const TONES = {
  green: "bg-green-50 text-green-700 border-green-200",
  blue: "bg-blue-50 text-[#0047FF] border-blue-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
  gray: "bg-neutral-100 text-neutral-700 border-neutral-200",
};

export function Tone({ tone = "gray", children, testid, className }) {
  return (
    <Badge variant="outline" data-testid={testid} className={cn("rounded-sm font-medium text-[11px] px-1.5 py-0", TONES[tone], className)}>
      {children}
    </Badge>
  );
}

export const CategoryBadge = ({ code, testid }) => <Tone tone={CAT_TONE[code]} testid={testid}>{CATEGORY_LABEL[code] || code}</Tone>;
export const ReviewBadge = ({ status, testid }) => <Tone tone={REVIEW_TONE[status]} testid={testid}>{REVIEW_LABEL[status] || status}</Tone>;
export const RecStatusBadge = ({ status, testid }) => <Tone tone={REC_TONE[status]} testid={testid}>{REC_STATUS[status] || status}</Tone>;
export const JobStatusBadge = ({ status, testid }) => <Tone tone={JOB_TONE[status]} testid={testid}>{JOB_STATUS[status] || status}</Tone>;
export const CheckBadge = ({ status, testid }) => <Tone tone={CHECK_TONE[status]} testid={testid}>{CHECK_LABEL[status] || status}</Tone>;
